// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"6d6e1fe7","488":"0c097a4c","672":"58660fe3"}[chunkId] + ".chunk.js";
};